import * as React from "react";

const SvgComponent = (props) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      {...props}
   >
      <style>
         {
            ".B{color-interpolation-filters:sRGB}.C{fill-opacity:1}.D{stroke:none}.E{fill:#020204}.F{stroke-linejoin:miter}.G{stroke-opacity:1}.H{stroke-width:1}.I{stroke-linecap:butt}.J{fill:#7c7c7c}"
         }
      </style>
      <defs>
         <filter id="G" x={-0.108} width={1.215} y={-0.108} height={1.217} className="B">
            <feGaussianBlur stdDeviation={3.924} />
         </filter>
         <filter id="H" className="B">
            <feGaussianBlur stdDeviation={2.437} />
         </filter>
         <filter id="I" className="B">
            <feGaussianBlur stdDeviation={0.37} />
         </filter>
         <filter id="K" x={-0.101} width={1.202} y={-0.043} height={1.085} className="B">
            <feGaussianBlur stdDeviation={1.132} />
         </filter>
         <filter id="M" x={-0.07} width={1.141} y={-0.151} height={1.301} className="B">
            <feGaussianBlur stdDeviation={1.025} />
         </filter>
         <filter id="O" x={-0.201} width={1.401} y={-0.234} height={1.468} className="B">
            <feGaussianBlur stdDeviation={2.844} />
         </filter>
         <filter id="P" x={-0.091} width={1.183} y={-0.107} height={1.213} className="B">
            <feGaussianBlur stdDeviation={1.297} />
         </filter>
         <filter id="Q" x={-0.469} width={1.939} y={-0.274} height={1.547} className="B">
            <feGaussianBlur stdDeviation={0.86} />
         </filter>
         <filter id="R" x={-0.604} width={2.208} y={-0.482} height={1.965} className="B">
            <feGaussianBlur stdDeviation={2.64} />
         </filter>
         <filter id="S" className="B">
            <feGaussianBlur stdDeviation={2.209} />
         </filter>
         <filter id="V" x={-0.145} width={1.29} y={-0.143} height={1.286} className="B">
            <feGaussianBlur stdDeviation={4.779} />
         </filter>
         <filter id="X" x={-0.115} width={1.231} y={-0.125} height={1.25} className="B">
            <feGaussianBlur stdDeviation={3.173} />
         </filter>
         <filter id="Y" x={-0.021} width={1.042} y={-0.129} height={1.259} className="B">
            <feGaussianBlur stdDeviation={0.479} />
         </filter>
         <filter id="Z" x={-0.178} width={1.355} y={-0.159} height={1.319} className="B">
            <feGaussianBlur stdDeviation={0.901} />
         </filter>
         <filter height={1.116} y={-0.058} width={2.633} x={-0.817} id="a" className="B">
            <feGaussianBlur stdDeviation={1.446} />
         </filter>
         <filter id="c" className="B">
            <feGaussianBlur stdDeviation={0.785} />
         </filter>
         <filter id="d" className="B">
            <feGaussianBlur stdDeviation={1.138} />
         </filter>
         <filter id="e" className="B">
            <feGaussianBlur stdDeviation={0.643} />
         </filter>
         <filter id="g" x={-0.118} width={1.235} y={-0.04} height={1.08} className="B">
            <feGaussianBlur stdDeviation={1.352} />
         </filter>
         <filter height={1.43} y={-0.215} width={1.31} x={-0.155} id="i" className="B">
            <feGaussianBlur stdDeviation={0.899} />
         </filter>
         <filter id="j" className="B">
            <feGaussianBlur stdDeviation={0.758} />
         </filter>
         <filter id="k" x={-0.161} width={1.322} y={-0.13} height={1.261} className="B">
            <feGaussianBlur stdDeviation={0.849} />
         </filter>
         <filter id="m" className="B">
            <feGaussianBlur stdDeviation={0.11} />
         </filter>
         <filter id="n" x={-0.116} width={1.233} y={-0.106} height={1.211} className="B">
            <feGaussianBlur stdDeviation={0.11} />
         </filter>
         <filter height={1.272} y={-0.136} width={1.215} x={-0.107} id="o" className="B">
            <feGaussianBlur stdDeviation={0.264} />
         </filter>
         <filter height={1.292} y={-0.146} width={1.469} x={-0.234} id="p" className="B">
            <feGaussianBlur stdDeviation={0.513} />
         </filter>
         <filter id="r" className="B">
            <feGaussianBlur stdDeviation={0.135} />
         </filter>
         <filter id="s" className="B">
            <feGaussianBlur stdDeviation={0.148} />
         </filter>
         <filter height={1.418} y={-0.209} width={1.316} x={-0.158} id="u" className="B">
            <feGaussianBlur stdDeviation={0.249} />
         </filter>
         <filter height={1.363} y={-0.181} width={1.357} x={-0.179} id="v" className="B">
            <feGaussianBlur stdDeviation={0.519} />
         </filter>
         <filter id="w" x={-0.292} width={1.584} y={-0.308} height={1.617} className="B">
            <feGaussianBlur stdDeviation={1.74} />
         </filter>
         <filter height={1.215} y={-0.107} width={1.108} x={-0.054} id="x" className="B">
            <feGaussianBlur stdDeviation={1.361} />
         </filter>
         <filter id="y" className="B">
            <feGaussianBlur stdDeviation={0.932} />
         </filter>
         <filter height={1.258} y={-0.129} width={1.153} x={-0.076} id="z" className="B">
            <feGaussianBlur stdDeviation={2.036} />
         </filter>
         <linearGradient id="C" xlinkHref="#Ac">
            <stop offset={0} stopColor="#3e2a06" />
            <stop offset={1} stopColor="#ad780a" />
         </linearGradient>
         <linearGradient xlinkHref="#C" id="D" x1={447.113} y1={364.09} x2={489.181} y2={300.828} />
         <linearGradient
            xlinkHref="#C"
            id="E"
            x1={442.039}
            y1={371.544}
            x2={490.122}
            y2={293.585}
         />
         <linearGradient id="b" xlinkHref="#Ac">
            <stop offset={0} />
            <stop offset={1} stopOpacity={0.25} />
         </linearGradient>
         <linearGradient id="l" xlinkHref="#Ac">
            <stop offset={0} stopColor="#3a2903" />
            <stop offset={0.555} stopColor="#735208" />
            <stop offset={1} stopColor="#ac8c04" />
         </linearGradient>
         <linearGradient id="q" xlinkHref="#Ac">
            <stop offset={0} stopColor="#646464" stopOpacity={0} />
            <stop offset={0.306} stopColor="#646464" stopOpacity={0.583} />
            <stop offset={0.47} stopColor="#646464" />
            <stop offset={0.728} stopColor="#646464" stopOpacity={0.257} />
            <stop offset={1} stopColor="#646464" stopOpacity={0} />
         </linearGradient>
         <linearGradient id="AD" x1={303.016} y1={132.77} x2={309.733} y2={140.725} xlinkHref="#Ac">
            <stop offset={0} stopColor="#949494" stopOpacity={0.392} />
            <stop offset={0.5} stopColor="#949494" />
            <stop offset={1} stopColor="#949494" stopOpacity={0.392} />
         </linearGradient>
         <linearGradient id="AE" x1={87.25} y1={119.987} x2={108.625} y2={132.487} xlinkHref="#Ac">
            <stop offset={0} stopColor="#747474" />
            <stop offset={0.125} stopColor="#8c8c8c" />
            <stop offset={0.25} stopColor="#a4a4a4" />
            <stop offset={0.5} stopColor="#d4d4d4" />
            <stop offset={0.619} stopColor="#d4d4d4" />
            <stop offset={1} stopColor="#7c7c7c" />
         </linearGradient>
         <linearGradient xlinkHref="#q" id="AF" x1={15.51} y1={105.562} x2={29.741} y2={118.997} />
         <linearGradient
            xlinkHref="#q"
            id="AG"
            x1={-25.773}
            y1={106.666}
            x2={-12.373}
            y2={119.571}
         />
         <linearGradient
            id="AH"
            x1={164.049}
            y1={132.063}
            x2={169.882}
            y2={142.493}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#757574" stopOpacity={0} />
            <stop offset={0.263} stopColor="#757574" />
            <stop offset={0.5} stopColor="#757574" />
            <stop offset={1} stopColor="#757574" stopOpacity={0} />
         </linearGradient>
         <linearGradient id="AJ" x1={46.857} y1={158.314} x2={103.337} y2={157.872} xlinkHref="#Ac">
            <stop offset={0} stopColor="#ad780a" />
            <stop offset={0.12} stopColor="#d89e08" />
            <stop offset={0.255} stopColor="#edb80b" />
            <stop offset={0.392} stopColor="#ebc80d" />
            <stop offset={0.527} stopColor="#f5d838" />
            <stop offset={0.769} stopColor="#f6d811" />
            <stop offset={1} stopColor="#f5cd31" />
         </linearGradient>
         <linearGradient
            id="AM"
            x1={243.031}
            y1={157.018}
            x2={243.469}
            y2={159.768}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#f5ce2d" />
            <stop offset={1} stopColor="#d79b08" />
         </linearGradient>
         <linearGradient id="AR" x1={28.286} y1={323.901} x2={31.982} y2={351.487} xlinkHref="#Ac">
            <stop offset={0} />
            <stop offset={1} stopOpacity={0} />
         </linearGradient>
         <linearGradient
            id="AS"
            x1={442.039}
            y1={371.544}
            x2={490.122}
            y2={293.585}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#3e2a06" />
            <stop offset={1} stopColor="#ad780a" />
         </linearGradient>
         <linearGradient id="AT" x1={45.164} y1={289.589} x2={43.75} y2={302.317} xlinkHref="#Ac">
            <stop offset={0} stopColor="#f3cd0c" />
            <stop offset={1} stopColor="#f3cd0c" stopOpacity={0} />
         </linearGradient>
         <linearGradient id="AX" x1={358.5} y1={279.362} x2={361.5} y2={279.237} xlinkHref="#Ac">
            <stop offset={0} stopColor="#7c7c7c" />
            <stop offset={1} stopColor="#7c7c7c" stopOpacity={0.33} />
         </linearGradient>
         <linearGradient id="AY" x1={123.134} y1={301.54} x2={170.864} y2={381.62} xlinkHref="#Ac">
            <stop offset={0} stopColor="#b98309" />
            <stop offset={1} stopColor="#382605" />
         </linearGradient>
         <linearGradient id="AZ" x1={171.04} y1={322.223} x2={186.066} y2={350.508} xlinkHref="#Ac">
            <stop offset={0} stopColor="#ebc40c" />
            <stop offset={1} stopColor="#ebc40c" stopOpacity={0} />
         </linearGradient>
         <linearGradient id="Ac" gradientUnits="userSpaceOnUse" />
         <radialGradient
            r={14.572}
            fy={137.661}
            fx={223.196}
            cy={137.661}
            cx={223.196}
            gradientTransform="matrix(1.08578 -.03431 .03944 1.24799 -154.542 -26.543)"
            id="A"
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#fefefc" />
            <stop offset={0.757} stopColor="#fefefc" />
            <stop offset={1} stopColor="#d4d4d4" />
         </radialGradient>
         <radialGradient
            r={14.572}
            fy={137.661}
            fx={223.196}
            cy={137.661}
            cx={223.196}
            gradientTransform="matrix(.81524 -.03431 .02961 1.24799 -129.437 -26.543)"
            id="B"
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#fefefc" />
            <stop offset={0.757} stopColor="#fefefc" />
            <stop offset={1} stopColor="#d4d4d4" />
         </radialGradient>
         <radialGradient
            id="AA"
            gradientTransform="matrix(.81524 -.03431 .02961 1.24799 -208.437 -35.543)"
            cx={223.196}
            cy={137.661}
            fx={223.196}
            fy={137.661}
            r={14.572}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#fefefc" />
            <stop offset={0.757} stopColor="#fefefc" />
            <stop offset={1} stopColor="#d4d4d4" />
         </radialGradient>
         <radialGradient
            id="AB"
            gradientTransform="matrix(1.08578 -.03431 .03944 1.24799 -233.542 -35.543)"
            cx={223.196}
            cy={137.661}
            fx={223.196}
            fy={137.661}
            r={14.572}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#fefefc" />
            <stop offset={0.757} stopColor="#fefefc" />
            <stop offset={1} stopColor="#d4d4d4" />
         </radialGradient>
         <radialGradient
            id="AC"
            gradientTransform="matrix(.69785 -.50717 .46034 .6334 -271.102 183.03)"
            cx={275.538}
            cy={150.651}
            fx={275.538}
            fy={150.651}
            r={15.382}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#020204" />
            <stop offset={0.734} stopColor="#020204" />
            <stop offset={1} stopColor="#5c5c5c" />
         </radialGradient>
         <radialGradient
            id="AI"
            gradientTransform="matrix(.93619 -.3864 .27133 .65739 -244.475 146.723)"
            cx={294.485}
            cy={193.099}
            fx={294.485}
            fy={193.099}
            r={31.111}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#d2940a" />
            <stop offset={0.751} stopColor="#d89c08" />
            <stop offset={0.866} stopColor="#b67e07" />
            <stop offset={1} stopColor="#946106" />
         </radialGradient>
         <radialGradient
            xlinkHref="#l"
            id="AK"
            gradientTransform="matrix(1 0 0 .58333 0 61.416)"
            cx={77.672}
            cy={147.093}
            fx={77.672}
            fy={147.093}
            r={3.23}
         />
         <radialGradient
            xlinkHref="#l"
            id="AL"
            gradientTransform="matrix(1 0 0 1.07512 0 -11.094)"
            cx={63.125}
            cy={147.441}
            fx={63.125}
            fy={147.441}
            r={1.535}
         />
         <radialGradient
            id="AN"
            gradientTransform="matrix(.20141 -.03316 .03065 .18616 -3.126 114.036)"
            cx={268.07}
            cy={126.535}
            fx={268.07}
            fy={126.535}
            r={35.511}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#c8c8c8" />
            <stop offset={1} stopColor="#797978" />
         </radialGradient>
         <radialGradient
            id="AO"
            gradientTransform="matrix(-.69844 0 0 .76336 166.306 50.22)"
            cx={336.224}
            cy={220.538}
            fx={336.224}
            fy={220.538}
            r={27.391}
            xlinkHref="#Ac"
         >
            <stop offset={0} />
            <stop offset={1} stopOpacity={0.25} />
         </radialGradient>
         <radialGradient
            xlinkHref="#b"
            id="AP"
            gradientTransform="matrix(1 0 0 .76336 -289 41.22)"
            cx={312.145}
            cy={236.366}
            fx={312.145}
            fy={236.366}
            r={27.391}
         />
         <radialGradient
            xlinkHref="#b"
            id="AQ"
            gradientTransform="matrix(1 0 0 1.06923 -289 -23.86)"
            cx={275.554}
            cy={225.135}
            fx={275.554}
            fy={225.135}
            r={10.845}
         />
         <radialGradient
            id="AU"
            gradientTransform="matrix(1.3082 .35053 -.36795 1.37322 -310.51 -240.35)"
            cx={363.34}
            cy={303.415}
            fx={363.34}
            fy={303.415}
            r={16.846}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#110800" />
            <stop offset={0.591} stopColor="#a65a00" stopOpacity={0.8} />
            <stop offset={1} stopColor="#ff921e" stopOpacity={0} />
         </radialGradient>
         <radialGradient
            id="AV"
            gradientTransform="matrix(1.3082 .35053 -.36795 1.37322 -310.51 -240.35)"
            cx={363.34}
            cy={303.415}
            fx={363.34}
            fy={303.415}
            r={16.846}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#110800" />
            <stop offset={0.591} stopColor="#a65a00" stopOpacity={0.8} />
            <stop offset={1} stopColor="#ff921e" stopOpacity={0} />
         </radialGradient>
         <radialGradient
            id="AW"
            gradientTransform="matrix(.36025 .1568 -.07247 .1665 260.617 181.938)"
            cx={382.235}
            cy={246.858}
            fx={382.235}
            fy={246.858}
            r={20.538}
            xlinkHref="#Ac"
         >
            <stop offset={0} stopColor="#7c7c7c" />
            <stop offset={1} stopColor="#7c7c7c" stopOpacity={0.33} />
         </radialGradient>
         <clipPath id="F">
            <path
               d="M137.577 281.02c1.6-.663 3.398-.784 5.1-.47s3.31 1.05 4.743 2.022c2.864 1.946 4.988 4.778 7.023 7.58 4.672 6.434 9.17 13.002 13.245 19.83 3.306 5.538 6.344 11.257 10.164 16.453 2.494 3.392 5.307 6.54 7.813 9.922s4.728 7.056 5.84 11.117c1.444 5.277.885 11.093-1.627 15.953-1.767 3.42-4.476 6.352-7.772 8.34s-7.17 3.014-11.016 2.87c-6.114-.23-11.7-3.285-17.384-5.55-11.58-4.612-24.16-6.06-36.097-9.652-3.67-1.104-7.276-2.41-10.97-3.426-1.64-.45-3.31-.848-4.86-1.55s-3-1.75-3.862-3.217c-.666-1.134-.948-2.47-.93-3.786s.326-2.615.774-3.852c.896-2.474 2.343-4.714 3.32-7.157 1.595-3.99 1.882-8.388 1.667-12.68s-.91-8.545-1.205-12.83c-.13-1.914-.18-3.853.185-5.736s1.176-3.725 2.558-5.055c1.274-1.227 2.965-1.955 4.696-2.317s3.515-.377 5.284-.338 3.54.134 5.304-.01 3.533-.54 5.07-1.418c1.46-.834 2.654-2.075 3.644-3.434s1.79-2.846 2.61-4.314 1.668-2.932 2.742-4.226 2.39-2.423 3.943-3.067"
               fill="#402c07"
               className="C D"
            />
         </clipPath>
         <clipPath id="J">
            <path
               d="M248.06 184.612s-5.106 6.345-7.897 10.247-5.737 6.65-8.587 10.75-7.365 9.432-9.45 13.93-2.32 9.036-4.265 13.85-3.7 10.642-5.97 15.336-5.37 9.685-6.94 13.536-3.81 5.724-4.108 10.22-.577 8.317 3.772 16.772 17.236 22.007 24.242 27.925 9.39 7.225 14.602 8.526 13.856 2.998 16.73-1.27 2.272-5.965-.75-10.666-4.825-5.302-9.796-9.573-18.637-14.873-22.682-19.24-7.107-3.412-5.53-6.284-2.207-4.01-2.658-7.693c-.764-6.245.944-18.7 1.46-22.133s1.224-2.924 3.518-8.04 4.124-8.624 7.05-13.467 8.625-10.128 11.15-15.278 3.504-10.72 4.362-15.318 1.746-12.13 1.746-12.13z"
               fill="none"
               stroke="#729fcf"
               strokeWidth={0.125}
               className="F G"
            />
         </clipPath>
         <clipPath id="L">
            <path
               d="M386.188 285.328c-.405-1.104-1.118-2.082-1.99-2.87s-1.9-1.392-2.983-1.852c-2.165-.92-4.52-1.26-6.832-1.696l-6.528-1.277c-2.27-.386-4.618-.632-6.865-.125-1.966.443-3.784 1.46-5.272 2.82s-2.65 3.056-3.485 4.9c-1.472 3.23-1.935 6.865-1.654 10.403.21 2.633.875 5.346 2.61 7.34 1.4 1.61 3.387 2.615 5.434 3.22a18.396 18.396 0 0 0 10.86-.155 28.59 28.59 0 0 0 14.33-10.779c1.14-1.65 2.112-3.448 2.553-5.403.336-1.5.348-3.08-.178-4.515"
               fill="none"
               stroke="#ce5c00"
               className="F G H I"
            />
         </clipPath>
         <clipPath id="N">
            <path
               d="M386.188 285.328c-.405-1.104-1.118-2.082-1.99-2.87s-1.9-1.392-2.983-1.852c-2.165-.92-4.52-1.26-6.832-1.696l-6.528-1.277c-2.27-.386-4.618-.632-6.865-.125-1.966.443-3.784 1.46-5.272 2.82s-2.65 3.056-3.485 4.9c-1.472 3.23-1.935 6.865-1.654 10.403.21 2.633.875 5.346 2.61 7.34 1.4 1.61 3.387 2.615 5.434 3.22a18.396 18.396 0 0 0 10.86-.155 28.59 28.59 0 0 0 14.33-10.779c1.14-1.65 2.112-3.448 2.553-5.403.336-1.5.348-3.08-.178-4.515"
               fill="none"
               stroke="#ce5c00"
               className="F G H I"
            />
         </clipPath>
         <clipPath id="T">
            <path
               d="M516.006 331.876c.91 1.597-1.57 3.388-2.816 4.738-2.742 2.973-6.45 4.902-9.896 7.02-5.914 3.635-12.62 5.903-18.42 9.717-3.883 2.553-7.328 5.722-10.86 8.742-3.022 2.584-5.482 5.876-8.832 8.018s-7.044 4.154-10.99 4.65c-4.783.6-9.872-.256-14.3-2.164-3.095-1.334-6.16-3.38-7.963-6.23-1.813-2.865-2.06-6.538-2.233-9.924-.307-6.06 1.363-12.06 2.178-18.073.68-5.002 1.853-9.943 2.26-14.975.74-9.142-.78-18.408.32-27.513.355-2.937-.18-6.66 2.012-8.644 2.038-1.845 5.43-1.12 8.18-1.063 3.345.07 6.632.95 9.89 1.717 2.056.483 3.998 1.41 6.072 1.81 3.44.663 6.966 1.066 10.467.952 3.785-.124 7.437-1.796 11.224-1.765 1.552.013 3.124.282 4.586.8 1.483.525 2.988 1.206 4.123 2.295.865.83 1.43 1.957 1.88 3.07.672 1.662.894 3.478 1.167 5.25.242 1.574-.153 3.27.414 4.76 1.83 4.8 5.577 8.727 9.225 12.343 1.743 1.935 4.03 3.534 6.167 4.828 2.27 1.374 4.368 2.45 5.463 4.816.66 1.485-.544 3.76.683 4.826z"
               fill="url(#E)"
               className="C D"
            />
         </clipPath>
         <clipPath id="U">
            <path
               d="M516.006 331.876c.91 1.597-1.57 3.388-2.816 4.738-2.742 2.973-6.45 4.902-9.896 7.02-5.914 3.635-12.62 5.903-18.42 9.717-3.883 2.553-7.328 5.722-10.86 8.742-3.022 2.584-5.482 5.876-8.832 8.018s-7.044 4.154-10.99 4.65c-4.783.6-9.872-.256-14.3-2.164-3.095-1.334-6.16-3.38-7.963-6.23-1.813-2.865-2.06-6.538-2.233-9.924-.307-6.06 1.363-12.06 2.178-18.073.68-5.002 1.853-9.943 2.26-14.975.74-9.142-.78-18.408.32-27.513.355-2.937-.18-6.66 2.012-8.644 2.038-1.845 5.43-1.12 8.18-1.063 3.345.07 6.632.95 9.89 1.717 2.056.483 3.998 1.41 6.072 1.81 3.44.663 6.966 1.066 10.467.952 3.785-.124 7.437-1.796 11.224-1.765 1.552.013 3.124.282 4.586.8 1.483.525 2.988 1.206 4.123 2.295.865.83 1.43 1.957 1.88 3.07.672 1.662.894 3.478 1.167 5.25.242 1.574-.153 3.27.414 4.76 1.83 4.8 5.577 8.727 9.225 12.343 1.743 1.935 4.03 3.534 6.167 4.828 2.27 1.374 4.368 2.45 5.463 4.816.66 1.485-.544 3.76.683 4.826z"
               fill="url(#E)"
               className="C D"
            />
         </clipPath>
         <clipPath id="W">
            <path
               d="M511.827 331.9c.795 1.296-1.374 2.75-2.464 3.845-2.4 2.413-5.644 3.978-8.66 5.697-5.174 2.95-11.04 4.8-16.116 7.885-3.397 2.072-6.41 4.644-9.502 7.094-2.644 2.097-4.796 4.77-7.728 6.506s-6.163 3.37-9.616 3.774c-4.185.488-8.637-.208-12.5-1.756-2.708-1.083-5.4-2.744-6.967-5.055-1.586-2.325-1.803-5.305-1.953-8.053-.27-4.918 1.192-9.787 1.906-14.666.594-4.06 1.62-8.07 1.977-12.152.647-7.418-.682-14.938.28-22.327.3-2.383-.158-5.404 1.76-7.014 1.783-1.497 4.75-.9 7.156-.862 2.927.058 5.803.772 8.652 1.393 1.8.392 3.498 1.145 5.313 1.47 3 .538 6.094.865 9.158.772 3.312-.1 6.506-1.458 9.82-1.432 1.358.01 2.733.23 4.013.65 1.297.426 2.614.98 3.607 1.862.757.674 1.25 1.588 1.644 2.5.588 1.35.782 2.822 1.02 4.26.212 1.277-.134 2.655.363 3.862 1.6 3.895 4.88 7.082 8.07 10.016 1.525 1.57 3.526 2.868 5.396 3.918 1.985 1.115 3.82 1.988 4.78 3.908.577 1.205-.476 3.052.598 3.917z"
               fill="url(#D)"
               className="C D"
            />
         </clipPath>
         <clipPath id="f">
            <path
               d="M304.847 225.45c6.016 4.923 9.777 12.317 10.943 20.003 1.825 12.03-2.346 24.075-6.446 35.533-.817 2.285-1.64 4.6-1.965 6.995s-.12 4.948 1.03 7.086c1.303 2.425 3.732 4.125 6.367 4.923 2.59.784 5.394.76 8.015.092s5.06-1.968 7.187-3.64c5.48-4.3 8.758-10.986 10-17.844s.64-13.93-.55-20.798c-1.623-9.37-4.31-18.54-7.74-27.408-2.518-6.507-5.468-12.91-9.618-18.52-4.046-5.47-9.162-10.1-13.103-15.635-2.732-3.844-4.9-8.13-8.192-11.508-1.646-1.69-3.577-3.135-5.77-4s-4.664-1.124-6.933-.482c-1.505.426-2.892 1.237-4.038 2.3s-2.053 2.376-2.693 3.803c-1.28 2.853-1.477 6.112-.965 9.198.66 3.983 2.444 7.693 4.466 11.19 2.274 3.932 4.918 7.72 8.384 10.654 3.6 3.047 7.962 5.074 11.61 8.06"
               fill="none"
               stroke="#c17d11"
               className="F G H I"
            />
         </clipPath>
         <clipPath id="h">
            <path
               d="M54.232 122.362c-3.792 4.79-8.518 11.69-8.193 17.25s3.86 13.935 8.375 16 5.754.013 8.33-2.5 3.86-7.348 4.006-12.25-3.035-11.92-5.44-15.25-3.287-8.04-7.08-3.25z"
               fill="url(#B)"
               className="C D"
            />
         </clipPath>
         <clipPath id="t">
            <path
               d="M85.75 122.362c-2.547 2.127-5.208 4.6-6.25 7.75-1.31 3.96-1.633 8.917.5 12.5 3.92 6.582 12.384 13.85 19.75 11.75 4.875-1.39 6.107-8.5 7-13.5.59-3.307.596-7.193-1.25-10-3.612-5.493-10.427-9.894-17-10-1.044-.017-1.95.83-2.75 1.5z"
               fill="url(#A)"
               className="C D"
            />
         </clipPath>
         <path
            id="Aa"
            d="M71.484 295.64c-.563-1.102-1.587-1.926-2.73-2.403s-2.397-.63-3.634-.62c-2.475.02-4.935.664-7.4.45-2.083-.18-4.06-.963-6.1-1.457-2.097-.5-4.322-.7-6.405-.143-2.226.606-4.19 2.094-5.42 4.045-1.084 1.72-1.6 3.753-1.76 5.78s.013 4.066.218 6.09c.148 1.464.314 2.93.668 4.36s.904 2.823 1.766 4.015c1.24 1.716 3.083 2.94 5.07 3.675a14.09 14.09 0 0 0 10.132-.177c5.66-2.457 10.45-6.864 13.37-12.3a26.256 26.256 0 0 0 2.382-6.165c.208-.853.372-1.722.38-2.6s-.147-1.77-.546-2.55z"
         />
         <path
            id="Ab"
            d="M362.22 276.456a13.48 13.48 0 0 0-1.625.188c-3.47.617-6.647 2.81-8.437 5.844a12.38 12.38 0 0 0-1.656 7.156c.073-1.742.53-3.447 1.375-4.97 1.434-2.582 4.032-4.53 6.938-5.062 1.8-.328 3.632-.13 5.438.094 1.733.216 3.48.443 5.188.813 2.64.572 5.254 1.45 7.47 3 .516.36 1 .77 1.406 1.25s.722 1.038.844 1.656c.178.904-.08 1.853-.53 2.656s-1.065 1.507-1.72 2.156a39.347 39.347 0 0 1-1.656 1.53c2.56-.496 5.152-1.198 7.28-2.687.9-.63 1.715-1.385 2.25-2.344s.762-2.12.5-3.187c-.177-.72-.57-1.382-1.062-1.937s-1.08-1.012-1.687-1.437a20.02 20.02 0 0 0-9.062-3.47c-2.08-.383-4.18-.706-6.28-.97-1.643-.206-3.32-.373-4.97-.28z"
         />
      </defs>
      <g className="E">
         <path d="M22.625 11.327c.348.76.738 1.5 1.084 2.26.665 1.465 1.171 3.01 1.381 4.605s.119 3.242-.38 4.77c-.562 1.727-1.632 3.262-2.942 4.519-1.55 1.487-3.539 2.633-5.685 2.717-1.398.055-2.79-.344-4.028-.996-1.04-.548-1.99-1.278-2.749-2.177s-1.32-1.97-1.581-3.116c-.32-1.412-.176-2.911.31-4.275.347-.976.862-1.884 1.229-2.853.4-1.058.624-2.188 1.155-3.188.48-.906 1.202-1.68 1.586-2.631.228-.569.328-1.18.476-1.774s.354-1.194.757-1.655c.485-.557 1.215-.859 1.948-.944s1.476.03 2.196.194c.573.13 1.139.293 1.693.49.472.168.94.364 1.35.655.557.396.98.954 1.319 1.549s.596 1.229.882 1.85z" />
         <path d="M16.467 30.212a19.3 19.3 0 0 1 1.76.18 17.723 17.723 0 0 1 1.528.3c.79.192 1.578.436 2.39.46.215.006.43-.004.639-.05s.412-.132.579-.265c.25-.199.407-.499.467-.813s.022-.64-.07-.946c-.184-.61-.578-1.132-.904-1.68-.187-.315-.353-.641-.556-.946s-.444-.589-.752-.787c-.425-.274-.952-.363-1.455-.313s-.985.232-1.434.464c-.63.326-1.222.774-1.565 1.394-.12.216-.206.448-.308.673s-.22.446-.392.623c-.191.197-.44.33-.638.52-.1.097-.186.207-.236.335s-.064.274-.017.403c.032.089.09.167.161.228s.157.106.246.137c.178.063.37.072.558.083z" />
         <path d="M14.716 30.174c-.491.011-.977.099-1.457.198-.46.095-.917.201-1.372.32-.766.202-1.533.442-2.325.46-.209.004-.419-.008-.622-.055s-.4-.13-.563-.26c-.249-.199-.407-.499-.466-.812s-.022-.638.068-.944c.182-.61.572-1.133.891-1.684.181-.313.342-.64.538-.943s.432-.59.734-.79c.413-.27.927-.362 1.418-.314s.96.23 1.394.466c.611.334 1.17.793 1.523 1.392.248.421.39.903.68 1.296.156.212.354.395.482.624.065.114.113.24.124.372s-.016.267-.09.376c-.049.072-.116.13-.192.174s-.16.07-.244.088c-.172.036-.346.03-.52.035zM11.972 9.727c-.069-.83-.053-1.665-.083-2.497-.03-.8-.104-1.6-.077-2.401.027-.814.164-1.639.526-2.37s.951-1.351 1.67-1.738c.674-.364 1.453-.52 2.22-.512 1.042.012 2.085.326 2.928.937.529.383.974.876 1.324 1.426.3.47.532.983.678 1.521.299 1.103.228 2.265.286 3.406.055 1.08.228 2.16.17 3.24-.013.236-.039.475-.143.686-.102.205-.275.37-.474.483s-.423.179-.65.214c-.452.07-.915.024-1.371.066-.662.061-1.294.307-1.95.408-.783.121-1.581.036-2.373.004-.317-.013-.635-.017-.95-.056s-.629-.116-.909-.265c-.171-.092-.331-.212-.46-.359s-.227-.321-.276-.512c-.073-.284-.035-.583-.034-.877.002-.268-.03-.535-.053-.803z" />
      </g>
      <path
         d="M13.218 9.407c-.112.14-.185.31-.23.484s-.06.354-.066.534c-.014.359.008.725-.087 1.072-.102.37-.33.691-.553 1.004-.386.542-.776 1.098-.967 1.736a3.081 3.081 0 0 0-.112 1.195 12.637 12.637 0 0 0-1.116 2.012 11.009 11.009 0 0 0-.906 3.357c-.139 1.418.043 2.877.603 4.188a6.86 6.86 0 0 0 1.787 2.49c.396.343.836.636 1.307.867 1.63.801 3.643.803 5.246-.051.837-.446 1.544-1.099 2.225-1.76.41-.397.82-.804 1.132-1.282.603-.92.813-2.039.943-3.131.229-1.91.236-3.928-.602-5.66a6.244 6.244 0 0 0-1.133-1.622 8.885 8.885 0 0 0-.717-2.414c-.254-.553-.564-1.078-.8-1.638-.097-.23-.182-.466-.288-.69s-.24-.443-.42-.615c-.185-.177-.415-.302-.658-.382s-.498-.116-.753-.13c-.51-.025-1.022.042-1.532.021-.407-.016-.812-.087-1.218-.063-.203.012-.406.048-.595.125s-.362.194-.489.353z"
         fill="#fdfdfb"
      />
      <path
         d="M-28.632 172.6c1.703 4.938 5.13 9.152 9.186 12.444 1.35 1.095 2.782 2.104 4.366 2.817s3.332 1.12 5.062.972c1.695-.144 3.307-.81 4.79-1.646s2.856-1.847 4.293-2.757c2.463-1.56 5.1-2.82 7.657-4.22 3.082-1.687 6.07-3.6 8.665-5.96 1.188-1.085 2.296-2.268 3.608-3.2s2.883-1.606 4.488-1.497c1.204.082 2.333.594 3.512.848.6.127 1.2.19 1.797.098s1.18-.344 1.598-.78c.512-.533.736-1.3.7-2.04s-.284-1.453-.63-2.107c-.69-1.308-1.735-2.435-2.2-3.838-.414-1.25-.33-2.6-.294-3.914s.008-2.69-.6-3.857c-.462-.89-1.236-1.595-2.122-2.064s-1.88-.7-2.876-.804c-1.995-.187-3.994.2-5.994.313-2.656.15-5.322-.182-7.977-.022-3.31.2-6.557 1.16-9.874 1.166-3.786.007-7.568-1.232-11.308-.64-1.605.254-3.135.838-4.676 1.352s-3.133.967-4.757.944c-1.844-.027-3.63-.665-5.47-.797-.92-.066-1.862 0-2.726.323s-1.645.924-2.068 1.743c-.243.47-.363.997-.386 1.525s.05 1.057.178 1.57c.255 1.026.724 1.983 1.1 2.967 1.393 3.554 1.692 7.448 2.937 11.056z"
         fillOpacity={0.26}
         filter="url(#z)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="M-54.38 165.474a39.427 39.427 0 0 1 8.77 8.052c2.313 2.884 4.28 6.154 7.3 8.29 2.133 1.508 4.695 2.358 7.294 2.616 3.052.303 6.14-.187 9.082-1.052 2.727-.802 5.363-1.93 7.782-3.42 4.598-2.836 8.44-6.993 13.5-8.857 1.107-.407 2.26-.698 3.327-1.2s2.07-1.254 2.58-2.318c.5-1.022.47-2.202.63-3.325.17-1.2.554-2.362.764-3.556s.235-2.472-.28-3.57c-.428-.91-1.205-1.628-2.1-2.085s-1.9-.664-2.904-.714c-2.006-.1-3.988.415-5.988.598-2.65.242-5.318-.1-7.977-.02-3.308.1-6.568.85-9.874 1.005-3.772.178-7.534-.418-11.308-.55-1.632-.058-3.275-.03-4.884.253s-3.188.822-4.55 1.726c-1.32.877-2.397 2.067-3.607 3.09-.605.512-1.248.985-1.954 1.345s-1.48.605-2.27.643c-.407.02-.818-.015-1.22.047a2.59 2.59 0 0 0-2.121 3.005z"
         transform="matrix(.10711 0 0 .09866 18.284 -6.521)"
         opacity={0.3}
         filter="url(#y)"
      />
      <path
         d="M-24.768 113.362c-1.78.097-3.485.92-4.788 2.137s-2.22 2.812-2.786 4.504c-1.13 3.384-.875 7.052-.62 10.6.233 3.222.47 6.505 1.677 9.502.603 1.498 1.45 2.9 2.58 4.064s2.552 2.042 4.118 2.434c1.47.368 3.038.292 4.483-.162s2.764-1.28 3.846-2.338c1.58-1.545 2.643-3.566 3.253-5.69s.784-4.352.752-6.56c-.04-2.764-.4-5.54-1.266-8.164s-2.246-5.103-4.173-7.086c-.933-.96-1.998-1.805-3.2-2.397s-2.543-.925-3.88-.853z"
         fill="url(#AA)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="M6.75 113.362c-2.78 1.9-5.11 4.575-6.25 7.75-1.436 4.002-.886 8.48.5 12.5 1.42 4.117 3.794 8.04 7.38 10.512 1.793 1.236 3.868 2.083 6.03 2.34s4.41-.095 6.34-1.1c2.353-1.226 4.148-3.373 5.262-5.78s1.59-5.07 1.738-7.72c.2-3.375-.14-6.806-1.25-10-1.205-3.47-3.4-6.67-6.473-8.667-1.54-.998-3.292-1.684-5.11-1.935s-3.705-.063-5.416.602c-.975.38-1.887.907-2.75 1.5z"
         fill="url(#AB)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="m-25.36 142.154-5.136 4.685c-.904.91-1.81 1.884-2.215 3.1-.36 1.08-.292 2.253-.47 3.38-.06.386-.15.77-.152 1.16a1.94 1.94 0 0 0 .078.578c.057.187.15.363.285.506.222.237.538.366.856.43s.645.072.968.107c1.456.157 2.798.863 4.004 1.695l3.55 2.585c2.73 1.734 5.993 2.505 9.226 2.628s6.458-.37 9.63-1.005c2.52-.504 5.034-1.1 7.425-2.044 3.663-1.444 6.964-3.667 10.118-6.022 1.433-1.07 2.846-2.173 4.133-3.415.437-.422.86-.86 1.328-1.246s.988-.722 1.566-.908c.88-.283 1.836-.202 2.748-.05.687.115 1.376.27 2.072.24.348-.014.697-.074 1.02-.204s.622-.33.843-.6a2.02 2.02 0 0 0 .442-1.272c.002-.458-.14-.91-.37-1.305-.465-.79-1.268-1.323-2.105-1.695-1.146-.51-2.386-.76-3.606-1.056a51.63 51.63 0 0 1-10.836-3.954c-1.716-.852-3.384-1.796-5.072-2.7-1.736-.93-3.505-1.824-5.39-2.395-4.213-1.277-8.82-.858-12.977.586a27.75 27.75 0 0 0-11.966 8.188z"
         opacity={0.3}
         filter="url(#x)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="M-16.4 136.862c1.767-1.987 2.976-4.41 4.674-6.457.85-1.023 1.828-1.955 2.982-2.617s2.492-1.04 3.817-.926c1.474.128 2.855.862 3.934 1.875s1.88 2.3 2.52 3.625c.612 1.278 1.098 2.64 1.98 3.75.94 1.184 2.26 1.992 3.45 2.923.596.465 1.167.97 1.638 1.56s.84 1.276.99 2.017a4.21 4.21 0 0 1-.185 2.267 5.08 5.08 0 0 1-1.26 1.904c-1.106 1.065-2.614 1.64-4.134 1.855-3.04.43-6.115-.476-9.184-.39-3.107.085-6.142 1.184-9.248 1.07-1.553-.057-3.128-.436-4.404-1.323a5.57 5.57 0 0 1-1.596-1.676 4.596 4.596 0 0 1-.673-2.206c-.025-.74.148-1.48.444-2.16s.713-1.302 1.182-1.876c.94-1.148 2.087-2.106 3.072-3.214z"
         fill="url(#AC)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         transform="matrix(.12342 0 0 .12342 -16.317 -9.622)"
         d="M277.96 90.857c-2.225 1.57-1.253 3.53-.296 5.498s-2.104 7.64-2.137 7.884 6.025-2.875 7.676-4.902c1.95-2.393 6.877 3.238 6.61 2.38.002-1.533-9.627-12.43-11.852-10.86z"
         filter="url(#w)"
         className="J"
      />
      <path
         d="M17.444 5.867c-.112.008-.22.046-.316.107s-.176.14-.24.233a1.206 1.206 0 0 0-.191.636c-.007.169.012.34.067.499s.15.306.28.413a.79.79 0 0 0 .962.044c.114-.078.204-.186.27-.307s.103-.255.12-.392c.032-.24-.003-.492-.114-.707s-.3-.394-.528-.478a.745.745 0 0 0-.31-.047z"
         className="E"
      />
      <path
         d="M304.656 137.612c-.866.342-2.237.127-2.616.977-.225.504.093 1.333.603 1.54 1.032.42 2.632-.34 3.05-1.375.18-.45-.093-1.16-.54-1.35-.165-.07-.33.14-.496.206z"
         fill="#141413"
         filter="url(#u)"
         transform="matrix(.10711 0 0 .10711 -14.921 -8.14)"
      />
      <path
         d="M308.625 139.862c1.16-1.16-.826-4.24-2.375-5.5-1.122-.913-4.39-1.87-4.25-.875s1.6 2.266 2.595 3.237c1.212 1.195 3.48 3.69 4.03 3.138z"
         fill="url(#AD)"
         filter="url(#v)"
         transform="matrix(.10711 0 0 .10711 -14.921 -8.14)"
      />
      <path
         d="M75.25 132.487a23.71 23.71 0 0 1 8.122-4.4c6.086-1.88 13-1.137 18.378 2.275 1.857 1.178 3.512 2.642 5.24 4.004s3.56 2.64 5.636 3.37c1.12.394 2.318.623 3.5.5 1.068-.112 2.1-.512 2.984-1.12s1.625-1.418 2.18-2.337c1.112-1.837 1.47-4.065 1.278-6.203-.383-4.277-2.796-8.053-4.818-11.84-.633-1.186-1.236-2.393-2-3.5-2.343-3.396-6.073-5.636-9.985-6.948s-8.046-1.786-12.14-2.302c-1.826-.23-3.673-.47-5.5-.25-2.1.253-4.076 1.1-6.125 1.625-.973.25-1.964.425-2.928.704s-1.913.67-2.697 1.296c-1.145.916-1.865 2.29-2.177 3.723s-.24 2.924-.012 4.372c.458 2.896 1.54 5.724 1.438 8.654-.07 2.012-.702 3.988-.625 6 .023.6.107 1.177.25 1.75"
         clipPath="url(#t)"
         transform="matrix(.10711 0 0 .10711 7.573 -8.14)"
         fill="url(#AE)"
      />
      <path
         d="M16.406 105.125c-.477.6-.908 1.252-1.25 1.97 2.146.462 4.2 1.346 6.03 2.563 3.545 2.354 6.237 5.796 8.125 9.625a10.04 10.04 0 0 0 1.188-1.594c-1.898-3.988-4.644-7.595-8.312-10.03-1.762-1.17-3.725-2.054-5.78-2.53z"
         fill="url(#AF)"
         filter="url(#s)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="M-24.97 107.08c-.242-.005-.477.017-.72.028l-.47.028c1.413.128 2.818.508 4.094 1.08 1.74.78 3.274 1.893 4.625 3.16 2.504 2.345 4.365 5.24 5.625 8.31a20.8 20.8 0 0 0-2.062-6.659 21.687 21.687 0 0 0-1.562-1.65c-1.35-1.266-2.886-2.378-4.625-3.16-1.52-.683-3.214-1.108-4.906-1.138z"
         fill="url(#AG)"
         filter="url(#r)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="M12.922 6.547c-.04.24-.042.493.041.723.054.151.145.288.254.407.072.077.153.147.248.193s.206.065.308.039c.094-.024.177-.085.238-.16s.101-.167.13-.26a1.443 1.443 0 0 0-.013-.848 1.107 1.107 0 0 0-.324-.528c-.077-.064-.166-.115-.263-.138s-.203-.018-.294.024c-.1.045-.179.133-.23.231s-.077.208-.095.317z"
         className="E"
      />
      <path
         d="M164.688 135.487c.242.634 1.054.864 1.5 1.375.433.497.887 1.01 1.125 1.625.455 1.176-.45 2.92.5 3.75.298.26.895.266 1.188 0 1.145-1.042.89-3.144.438-4.625-.41-1.344-1.427-2.616-2.68-3.255-.58-.295-1.45-.54-1.946-.12-.32.27-.274.86-.125 1.25z"
         fill="url(#AH)"
         filter="url(#p)"
         transform="matrix(.10711 0 0 .10711 -4.21 -8.14)"
      />
      <g transform="matrix(.10711 0 0 .10711 7.573 -8.14)">
         <path
            d="M45.752 165.032c.06.295.173.58.327.84.266.445.654.806 1.073 1.11s.873.56 1.312.835c2.334 1.467 4.235 3.53 5.925 5.707 2.267 2.922 4.272 6.165 7.3 8.29 2.138 1.5 4.696 2.355 7.294 2.616 3.05.307 6.14-.186 9.082-1.052 2.726-.803 5.363-1.93 7.782-3.42 4.6-2.836 8.44-6.993 13.5-8.857 1.107-.407 2.26-.698 3.326-1.2s2.07-1.254 2.58-2.318c.5-1.022.47-2.202.63-3.325.17-1.2.554-2.362.764-3.556s.235-2.472-.28-3.57c-.428-.91-1.205-1.628-2.1-2.085s-1.9-.664-2.904-.714c-2.006-.1-3.988.415-5.988.598-2.65.242-5.318-.098-7.977-.02-3.308.1-6.568.845-9.874 1.005-3.772.183-7.535-.4-11.308-.55-1.634-.066-3.28-.05-4.892.225s-3.195.824-4.54 1.753c-1.31.906-2.356 2.14-3.56 3.184-.602.522-1.25 1-1.966 1.347s-1.507.564-2.304.547c-.4-.01-.83-.077-1.22.047-.244.077-.46.227-.644.406s-.335.387-.478.6a10.52 10.52 0 0 0-.867 1.558z"
            fill="url(#AI)"
         />
         <path
            d="M60.557 169.097a6.7 6.7 0 0 0 4.346 7.847c1.978.66 4.207.336 6.055-.628 1.07-.56 2.05-1.346 2.67-2.384a4.51 4.51 0 0 0 .605-1.696c.08-.6.025-1.22-.185-1.785-.23-.62-.64-1.168-1.146-1.596s-1.105-.738-1.733-.946c-1.258-.416-2.61-.424-3.934-.36a38.86 38.86 0 0 0-5.969.753"
            fill="#d9b30d"
            filter="url(#i)"
         />
         <path
            d="m54.066 156.68-3.898 2.563c-.657.466-1.334.97-1.68 1.696-.246.515-.302 1.1-.3 1.67s.03 1.144-.046 1.7c-.05.386-.154.766-.172 1.155-.01.195.005.39.056.58a1.2 1.2 0 0 0 .275.509c.173.183.408.296.65.37s.49.11.736.17c1.175.276 2.197.997 3.094 1.804l2.64 2.476c2.537 2.064 5.9 2.92 9.16 2.973s6.504-.63 9.695-1.35l7.425-2.044c3.703-1.365 7.14-3.432 10.118-6.022 1.35-1.174 2.617-2.464 4.133-3.415 1.34-.842 2.843-1.398 4.206-2.203.122-.072.243-.146.352-.237s.206-.198.27-.325c.11-.22.11-.48.04-.716s-.206-.444-.36-.634a4.384 4.384 0 0 0-.57-.578c-1.424-1.22-3.357-1.662-5.226-1.81s-3.76-.043-5.6-.352c-1.74-.3-3.393-.94-5.072-1.477a37.34 37.34 0 0 0-5.389-1.31c-4.295-.7-8.717-.566-12.977.32a37.928 37.928 0 0 0-11.54 4.48z"
            fill="#604405"
            filter="url(#j)"
         />
         <path
            d="M53.64 152.154a23.787 23.787 0 0 0-5.136 4.685c-.84 1.03-1.604 2.15-2.027 3.412-.333.992-.446 2.042-.656 3.067-.08.384-.17.77-.17 1.16.001.196.026.393.086.58s.158.362.294.503c.225.234.54.36.858.426s.644.075.966.112c1.455.165 2.794.872 4 1.702l3.554 2.578c2.734 1.73 5.995 2.498 9.227 2.623s6.457-.366 9.63-1c2.52-.503 5.034-1.1 7.425-2.044 3.662-1.444 6.964-3.667 10.118-6.022 1.433-1.07 2.846-2.173 4.133-3.415.437-.422.86-.86 1.328-1.246s.988-.722 1.566-.908c.88-.283 1.836-.202 2.748-.05.687.115 1.376.27 2.072.24.348-.014.697-.074 1.02-.204s.622-.33.843-.6a2.02 2.02 0 0 0 .442-1.272c.002-.458-.14-.91-.37-1.305-.465-.79-1.268-1.323-2.105-1.695-1.146-.51-2.386-.76-3.606-1.056a51.63 51.63 0 0 1-10.836-3.954c-1.716-.852-3.384-1.796-5.072-2.7-1.736-.93-3.505-1.824-5.39-2.395-4.213-1.277-8.82-.858-12.977.586a27.75 27.75 0 0 0-11.966 8.188z"
            fill="url(#AJ)"
         />
         <path
            d="M83.24 153.08c-.226-.286-.55-.488-.9-.59s-.725-.1-1.084-.05c-.72.123-1.364.5-1.966.925-1.71 1.176-3.22 2.628-4.537 4.23-1.745 2.12-3.185 4.572-3.668 7.275-.08.455-.135.92-.078 1.38s.233.915.56 1.243c.286.288.676.464 1.078.522s.816.002 1.2-.128c.77-.26 1.41-.8 2.014-1.34 3.336-2.985 6.353-6.568 7.56-10.88.12-.433.224-.876.22-1.325s-.12-.91-.398-1.262z"
            fill="#f6da4a"
            filter="url(#k)"
         />
         <path
            d="M75.25 146.9c.23.742 1.428.62 2.12.975.607.312 1.094.997 1.777 1.017.65.02 1.664-.225 1.75-.87.112-.853-1.134-1.395-1.935-1.708-1.03-.402-2.353-.606-3.32-.068-.222.123-.464.412-.388.655z"
            opacity={0.8}
            fill="url(#AK)"
            filter="url(#m)"
         />
         <path
            d="M63.827 146.47c-.888-.29-2.357 1.277-1.878 2.08.132.22.535.5.806.35.41-.225.744-1.03 1.187-1.345.296-.21.23-.972-.116-1.084z"
            opacity={0.8}
            fill="url(#AL)"
            filter="url(#n)"
         />
         <ellipse
            transform="matrix(1.09562 0 -.17018 1.51813 -136.244 -82.117)"
            cx={243.297}
            cy={158.284}
            rx={2.608}
            ry={2.328}
            fill="url(#AM)"
            filter="url(#o)"
         />
         <path
            d="M50.392 129.527c2.685-1.6 5.955-1.97 9.067-1.676s6.125 1.208 9.14 2.03c2.212.602 4.452 1.16 6.525 2.138s4 2.416 5.142 4.403l.54.962c.194.312.423.61.716.83s.657.364 1.024.344c.184-.01.366-.06.524-.154s.293-.23.378-.392c.098-.187.128-.404.117-.616a2.94 2.94 0 0 0-.117-.622c-.755-2.753-2.535-5.088-3.89-7.6l-2.298-4.596c-2.818-5.16-7.444-9.216-12.7-11.847s-11.127-3.896-16.997-4.24c-6.8-.398-13.62.41-20.33 1.59-2.91.512-5.86 1.115-8.436 2.562-1.287.723-2.467 1.657-3.388 2.81s-1.576 2.535-1.788 3.997c-.204 1.41.01 2.86.5 4.196s1.258 2.558 2.157 3.662c1.797 2.208 4.1 3.934 6.222 5.83s4.1 3.992 6.463 5.563c1.186.785 2.473 1.435 3.843 1.817s2.83.49 4.224.204c1.445-.296 2.783-1.005 3.954-1.902s2.186-1.98 3.148-3.098c1.925-2.236 3.723-4.686 6.257-6.196z"
            clipPath="url(#h)"
            fill="url(#AN)"
         />
      </g>
      <path
         d="M23.115 16.01c.652.524 1.065 1.316 1.193 2.142.1.645.035 1.306-.11 1.942s-.37 1.251-.593 1.864c-.089.245-.178.491-.213.75s-.013.53.111.758c.143.262.409.443.695.528.282.084.587.082.872.01s.553-.21.785-.39c.591-.46.948-1.173 1.086-1.908s.074-1.495-.054-2.231a15.033 15.033 0 0 0-.844-2.936c-.276-.698-.598-1.384-1.049-1.984-.44-.587-.996-1.081-1.428-1.675-.3-.412-.541-.873-.9-1.234-.18-.181-.39-.336-.629-.428s-.504-.12-.75-.05c-.323.09-.589.345-.729.65s-.165.657-.11.988c.07.428.266.826.487 1.2.25.42.538.827.914 1.14.393.328.868.543 1.266.864z"
         className="E"
      />
      <path
         transform="matrix(.10905 0 0 .10711 -10.129 -8.14)"
         clipPath="url(#f)"
         d="m290.78 216.018 1.5 1.375c3.667 3.055 5.62 6.485 9.338 9.477 6.085 4.895 12.26 13.344 13.454 21.06.932 6.02-.3 9.29-1.805 16.388s-5.77 17.148-8.074 23.992c-.92 2.73 1.86 1.603 1.496 4.48a17.72 17.72 0 0 0-.035 4.259l.07-.822c.443-3.923 1.623-7.695 2.91-11.395 2.474-7.122 5.314-14.1 7.272-21.408s1.74-12.564.72-18.844c-1.285-7.896-5.797-15.187-12.187-20-4.52-3.403-9.847-5.585-14.656-8.562z"
         fill="#838384"
         filter="url(#g)"
      />
      <path
         d="M-61.003 211.593c.88 1.524-.547 6.778 19.964 3.415 0 0-3.602.457-7.153 1.404-5.52 2.133-10.33 4.517-14.04 7.675-3.676 3.122-6.367 7.197-9.74 10.697 0 0 5.462-11.52 6.823-14.987s-.228-3.3.85-8.414 3.713-10.007 3.713-10.007-2.152 7.21-.417 10.216z"
         transform="matrix(.12364 0 0 .10711 18.962 -8.14)"
         opacity={0.25}
         fill="url(#AO)"
         filter="url(#e)"
      />
      <path
         d="M33.05 201.218c-4.825 3.36-7.652 2.963-13.507 3.62s-21.698.42-21.698.42 2.294-.043 7.378.904 15.453 1.852 21.292 4.075 7.968 2.857 11.517 5.1c5.05 3.194 8.758 8.197 13.587 11.697 0 0 .234-4.644-1.716-8.112s-7.2-8.935-8.732-14.04-2.274-15.132-2.274-15.132-1.02 8.105-5.846 11.466z"
         opacity={0.42}
         fill="url(#AP)"
         filter="url(#d)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="m-12.33 194.04-.697 4.344c-.14.71-.295 1.42-.56 2.093s-.644 1.312-1.18 1.796c-.47.424-1.044.716-1.62.98a24.352 24.352 0 0 1-7.108 2.02l2.935.268c.615.067 1.232.142 1.832.296s1.185.4 1.684.755c.548.4.978.948 1.3 1.546.64 1.192.854 2.563.973 3.9.15 1.723.162 3.46.033 5.184.116-1.154.358-2.296.72-3.398.653-1.986 1.704-3.848 3.12-5.386a11.66 11.66 0 0 1 1.86-1.648 10.29 10.29 0 0 1 7.236-1.761 11.24 11.24 0 0 1-7.194-2.233c-1.042-.785-1.95-1.763-2.58-2.905a8.11 8.11 0 0 1-.751-5.861z"
         opacity={0.2}
         fill="url(#AQ)"
         filter="url(#c)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="M-18.5 228.08a88.71 88.71 0 0 0-2.526 14.277c-.637 6.812-.484 13.672-.85 20.505-.3 5.798-.99 11.656.016 17.374a29.84 29.84 0 0 0 2.555 7.875 26.9 26.9 0 0 0 .422-2.876c.427-4.636-.354-9.287-.618-13.935-.462-8.147.666-16.3 1.125-24.438a149.28 149.28 0 0 0-.125-18.781z"
         opacity={0.1}
         filter="url(#a)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="M37.688 157.862c-2.162 1.97 1.014 4.928 2.52 8.404.936 2.16 3.527 5.205 6.032 4.718 1.885-.367 3.054-3.08 2.876-4.99-.344-3.69-3.457-4.553-5.717-5.82-1.79-1.004-4.193-3.694-5.71-2.31z"
         fill="#838384"
         filter="url(#Z)"
         transform="matrix(.10711 0 0 .10711 16.035 -7.175)"
      />
      <path
         d="M86.056 328.132a16.61 16.61 0 0 1-2.05 4.411c-1.98 3.012-4.854 5.28-7.727 7.37-4.9 3.566-10.003 6.838-14.563 10.9-3.056 2.715-5.84 5.76-8.423 8.965-2.208 2.74-4.284 5.62-6.8 8.057-2.54 2.46-5.53 4.447-8.752 5.53-3.918 1.317-8.058 1.253-11.832.26-2.645-.696-5.224-1.907-6.862-4.097-1.645-2.198-2.178-5.152-2.368-8.052-.337-5.13.26-10.37.803-15.575.452-4.326.868-8.655 1.04-12.972.3-7.852-.197-15.636-1.232-23.273-.173-1.28-.362-2.568-.257-3.886s.535-2.688 1.436-3.705c.832-.94 1.993-1.496 3.15-1.77s2.33-.3 3.493-.32c2.74-.075 5.496-.24 8.195.006 1.703.156 3.373.475 5.073.643 2.838.28 5.78.133 8.627-.724 3.064-.922 5.986-2.652 9.1-3.127a12.937 12.937 0 0 1 3.8.006c1.267.182 2.528.542 3.502 1.336.74.604 1.282 1.433 1.706 2.317.63 1.317 1.02 2.77 1.24 4.26.197 1.32.266 2.68.598 3.957.545 2.1 1.78 3.886 3.267 5.34s3.225 2.602 4.96 3.734c1.73 1.127 3.468 2.247 5.315 3.176.867.436 1.758.83 2.586 1.333s1.6 1.12 2.15 1.935c.746 1.105 1.046 2.553.822 3.975"
         transform="matrix(.11 0 0 .10711 18.036 -8.14)"
         opacity={0.2}
         fill="url(#AR)"
         filter="url(#S)"
      />
      <path
         d="M516.006 331.876a16.878 16.878 0 0 1-2.816 4.738c-2.624 3.115-6.268 5.17-9.896 7.02-6.19 3.154-12.602 5.922-18.42 9.717-3.898 2.542-7.496 5.527-10.86 8.742-2.877 2.75-5.606 5.687-8.832 8.018-3.256 2.35-7.02 4.054-10.99 4.65-4.83.725-9.82-.213-14.3-2.164-3.138-1.367-6.156-3.323-7.963-6.23-1.814-2.918-2.228-6.488-2.233-9.924-.008-6.077 1.118-12.1 2.178-18.073.88-4.972 1.72-9.955 2.26-14.975.983-9.13.976-18.353.32-27.513-.1-1.534-.238-3.083-.008-4.604s.855-3.037 2.02-4.04c1.077-.927 2.52-1.336 3.94-1.414s2.834.147 4.24.352c3.313.484 6.652.865 9.89 1.717 2.043.537 4.033 1.26 6.072 1.81 3.403.92 6.966 1.36 10.467.952 3.77-.44 7.43-1.857 11.224-1.765 1.557.038 3.1.332 4.586.8 1.515.478 3.01 1.162 4.123 2.295.846.86 1.436 1.945 1.88 3.07.66 1.674 1.015 3.457 1.167 5.25.135 1.588.113 3.194.414 4.76.495 2.575 1.847 4.923 3.528 6.935s3.7 3.72 5.696 5.408c2 1.68 4.01 3.355 6.167 4.828 1.012.692 2.056 1.34 3.017 2.1s1.845 1.647 2.445 2.715a6.783 6.783 0 0 1 .683 4.826z"
         clipPath="url(#T)"
         fill="url(#AS)"
         transform="matrix(.10711 0 0 .10711 -25.633 -8.14)"
      />
      <path
         d="M512.89 328.724a15.31 15.31 0 0 1-2.571 4.26c-2.402 2.814-5.73 4.654-9.038 6.31-5.653 2.83-11.503 5.318-16.82 8.735-3.554 2.284-6.84 4.966-9.918 7.86-2.63 2.473-5.125 5.116-8.066 7.208-2.98 2.12-6.418 3.647-10.037 4.18-4.41.65-8.96-.193-13.058-1.946-2.857-1.222-5.617-2.97-7.272-5.6-1.646-2.617-2.03-5.83-2.04-8.922-.013-5.465 1.018-10.87 1.99-16.248.807-4.47 1.575-8.948 2.064-13.463.89-8.208.848-16.498.292-24.735-.093-1.38-.2-2.774.012-4.14s.778-2.727 1.826-3.63c.983-.847 2.303-1.218 3.6-1.286s2.587.142 3.87.33c3.023.445 6.072.78 9.03 1.543 1.865.482 3.684 1.132 5.545 1.628 3.11.83 6.362 1.225 9.56.856 3.44-.397 6.787-1.67 10.25-1.587 1.42.035 2.83.3 4.19.72 1.382.426 2.75 1.034 3.765 2.063.766.775 1.295 1.754 1.716 2.76.626 1.497 1.033 3.097 1.066 4.72.035 1.694-.336 3.395-.106 5.073.186 1.363.763 2.648 1.5 3.81s1.634 2.21 2.523 3.26c1.717 2.03 3.44 4.097 5.593 5.655 2.452 1.774 5.362 2.81 7.895 4.467.755.494 1.486 1.052 2.018 1.78a4.76 4.76 0 0 1 .624 4.339z"
         clipPath="url(#U)"
         fill="#cd8907"
         filter="url(#V)"
         transform="matrix(.10711 0 0 .10711 -25.633 -8.14)"
      />
      <path
         d="M508.793 327.925a14.941 14.941 0 0 1-2.31 3.49c-2.153 2.428-5.06 4.1-8.123 5.172-5.042 1.767-10.546 2.004-15.495 4.016-3.016 1.226-5.73 3.073-8.48 4.82-2.222 1.41-4.492 2.77-6.932 3.756-2.755 1.115-5.686 1.74-8.626 2.18-1.87.28-3.763.484-5.652.387s-3.784-.507-5.45-1.4c-1.264-.678-2.4-1.653-3.076-2.918-.75-1.406-.88-3.056-.862-4.65.046-4.246 1.026-8.446.996-12.692-.026-3.696-.815-7.345-1.042-11.034-.437-7.095 1.205-14.313-.24-21.273-.23-1.114-.542-2.227-.527-3.365.008-.57.1-1.14.315-1.667s.563-1.005 1.025-1.338c.39-.28.85-.45 1.323-.527s.957-.062 1.432.007c.948.137 1.852.482 2.775.737 2.642.73 5.433.714 8.117 1.265 1.685.346 3.317.91 4.984 1.334 2.8.7 5.72 1.013 8.592.7 3.09-.335 6.107-1.375 9.213-1.3 1.273.03 2.537.25 3.765.59s2.455.82 3.384 1.69c.67.628 1.15 1.43 1.542 2.26.57 1.212.967 2.53.958 3.868-.005.697-.12 1.388-.187 2.08s-.088 1.404.09 2.077.554 1.287.983 1.84.915 1.06 1.358 1.602c1.242 1.517 2.13 3.285 3.097 4.99s2.052 3.393 3.58 4.62c2.08 1.672 4.778 2.34 7.096 3.66.68.387 1.337.84 1.814 1.46a3.77 3.77 0 0 1 .561 3.556z"
         transform="matrix(.12243 0 0 .132 -33.023 -16.4)"
         clipPath="url(#W)"
         fill="#f5c021"
         filter="url(#X)"
      />
      <path
         d="M27.31 290.65c3.276-.887 6.066 1.597 8.442 3.472 1.535 1.31 3.753.98 5.637 1.042 3.12-.113 6.225.523 9.347.136 6.145-.52 12.168-2.03 18.342-2.3 2.95-.186 6.26-.357 8.808 1.365 1.033.716 2.547 3.74 3.566 2.605-.42-3.178-2.777-6.256-5.94-7.102-2.475-.39-5 .29-7.49.07-7.423-.177-14.793-1.555-22.234-1.16-5.176.045-10.347-.195-15.515-.397-2.03-.415-2.747 1.39-3.85 2.08"
         fill="url(#AT)"
         filter="url(#Y)"
         transform="matrix(.10711 0 0 .10711 18.284 -8.14)"
      />
      <g className="J">
         <path
            d="M361.75 209.343c.002-1.533-7.565-10.056-9.8-8.486s-.492 3.784-.296 5.498-.945 6.61.238 7.26 3.366-2.52 5.3-4.277c1.558-1.415 4.544 1.54 4.546.006z"
            transform="matrix(-.01028 -.1025 -.08299 .0127 43.874 50.945)"
            opacity={0.75}
            filter="url(#R)"
         />
         <path
            transform="matrix(-.00749 .1025 -.06047 -.0127 26.485 -21.21)"
            d="M351.96 200.857c-1.452.39-1.23 3.994-.296 5.498.79 1.27 3.072 2.27 3.76 1.005 1.114-2.056-1.472-7.036-3.462-6.503z"
            opacity={0.25}
            filter="url(#Q)"
         />
      </g>
      <g transform="matrix(.10711 0 0 .10711 18.284 -8.14)">
         <use xlinkHref="#Aa" opacity={0.35} fill="url(#AU)" filter="url(#O)" />
         <use
            xlinkHref="#Aa"
            transform="matrix(1 0 0 .72293 0 80.758)"
            opacity={0.35}
            fill="url(#AV)"
            filter="url(#P)"
         />
         <path
            d="M76.188 285.328c-.405-1.104-1.118-2.082-1.99-2.87s-1.9-1.392-2.983-1.852c-2.165-.92-4.52-1.26-6.832-1.696l-6.528-1.277c-2.27-.386-4.618-.632-6.865-.125-1.966.443-3.784 1.46-5.272 2.82s-2.65 3.056-3.485 4.9c-1.472 3.23-1.935 6.865-1.654 10.403.21 2.633.875 5.346 2.61 7.34 1.4 1.61 3.387 2.615 5.434 3.22a18.396 18.396 0 0 0 10.86-.155 28.59 28.59 0 0 0 14.33-10.779c1.14-1.65 2.112-3.448 2.553-5.403.336-1.5.348-3.08-.178-4.515z"
            className="E"
         />
         <g transform="translate(-310)">
            <use xlinkHref="#Ab" clipPath="url(#L)" fill="url(#AW)" filter="url(#M)" />
            <use xlinkHref="#Ab" clipPath="url(#N)" fill="url(#AX)" filter="url(#M)" />
         </g>
      </g>
      <path
         d="m11.696 11.615-1.812 2.27c-.379.469-.766.941-1.013 1.492-.211.472-.311.986-.456 1.483-.165.565-.389 1.11-.64 1.643-.232.49-.487.97-.743 1.45-.186.348-.376.705-.44 1.094-.051.308-.022.626.057.929s.203.59.347.868c.607 1.186 1.518 2.209 2.596 2.991a9.13 9.13 0 0 0 1.564.913c.298.136.613.258.94.264.164.002.33-.025.48-.09s.283-.172.372-.31c.11-.169.147-.379.125-.579s-.1-.391-.205-.563c-.257-.42-.66-.724-1.049-1.026a35.103 35.103 0 0 1-2.43-2.06c-.22-.205-.439-.416-.592-.674a2.522 2.522 0 0 1-.285-.824c-.15-.787-.111-1.615.157-2.37.105-.296.243-.578.377-.862.231-.491.45-.992.755-1.442.379-.56.885-1.035 1.194-1.637.26-.507.366-1.078.467-1.64l.234-1.32z"
         className="E"
      />
      <path
         d="M232.33 224.27a33 33 0 0 0-5.953 7.318c-2.668 4.46-4.24 9.468-6.178 14.29-1.444 3.59-3.125 7.193-3.327 11.056-.103 1.984.19 3.966.257 5.952s-.118 4.05-1.1 5.784a7 7 0 0 1-3.733 3.144 11.07 11.07 0 0 1 5.335 3.865c1.115 1.5 1.828 3.254 2.796 4.85.787 1.298 1.753 2.5 2.943 3.445s2.61 1.62 4.117 1.813a7.26 7.26 0 0 0 5.765-1.842 135.289 135.289 0 0 1 5.15-53.8c.335-1.095.687-2.198.77-3.34s-.13-2.348-.824-3.258a3.53 3.53 0 0 0-4.9-.69c-.49.364-.882.857-1.127 1.415z"
         clipPath="url(#J)"
         transform="matrix(.10711 0 0 .10711 -14.921 -8.14)"
         opacity={0.95}
         filter="url(#K)"
         className="J"
      />
      <g transform="matrix(.10711 0 0 .10711 -7.423 -8.14)" clipPath="url(#F)">
         <path
            d="M137.577 281.02c1.6-.663 3.398-.784 5.1-.47s3.31 1.05 4.743 2.022c2.864 1.946 4.988 4.778 7.023 7.58 4.672 6.434 9.17 13.002 13.245 19.83 3.306 5.538 6.344 11.257 10.164 16.453 2.494 3.392 5.307 6.54 7.813 9.922s4.728 7.056 5.84 11.117c1.444 5.277.885 11.093-1.627 15.953-1.767 3.42-4.476 6.352-7.772 8.34s-7.17 3.014-11.016 2.87c-6.114-.23-11.7-3.285-17.384-5.55-11.58-4.612-24.16-6.06-36.097-9.652-3.67-1.104-7.276-2.41-10.97-3.426-1.64-.45-3.31-.848-4.86-1.55s-3-1.75-3.862-3.217c-.666-1.134-.948-2.47-.93-3.786s.326-2.615.774-3.852c.896-2.474 2.343-4.714 3.32-7.157 1.595-3.99 1.882-8.388 1.667-12.68s-.91-8.545-1.205-12.83c-.13-1.914-.18-3.853.185-5.736s1.176-3.725 2.558-5.055c1.274-1.227 2.965-1.955 4.696-2.317s3.515-.377 5.284-.338 3.54.134 5.304-.01 3.533-.54 5.07-1.418c1.46-.834 2.654-2.075 3.644-3.434s1.79-2.846 2.61-4.314 1.668-2.932 2.742-4.226 2.39-2.423 3.943-3.067z"
            fill="url(#AY)"
         />
         <path
            d="M140.1 283.78c1.455-.586 3.094-.65 4.623-.304s2.95 1.1 4.188 2.047c2.478 1.914 4.2 4.614 5.854 7.27 3.97 6.433 7.85 12.934 11.516 19.567 2.777 4.993 5.425 10.093 8.837 14.68 2.264 3.042 4.847 5.83 7.158 8.837s4.37 6.282 5.393 9.933c1.316 4.706.783 9.9-1.495 14.233a18.98 18.98 0 0 1-7.186 7.513 18.5 18.5 0 0 1-10.087 2.488c-5.598-.258-10.71-3.054-15.98-4.95-10.103-3.666-21.053-4.158-31.416-7.02-3.715-1.008-7.337-2.353-11.07-3.294-1.652-.417-3.333-.757-4.902-1.42s-3.047-1.69-3.898-3.165c-.633-1.097-.886-2.388-.847-3.654s.36-2.5.8-3.694c.902-2.367 2.32-4.5 3.23-6.875 1.38-3.574 1.55-7.504 1.294-11.326s-.92-7.61-1.153-11.434c-.104-1.71-.12-3.44.226-5.116s1.076-3.3 2.295-4.512c1.32-1.31 3.14-2.024 4.977-2.304s3.706-.158 5.555.007 3.705.373 5.56.262 3.736-.563 5.27-1.607c1.397-.945 2.446-2.324 3.244-3.798s1.368-3.055 1.976-4.617 1.267-3.122 2.222-4.5 2.236-2.605 3.806-3.235"
            fill="#d99a03"
            filter="url(#G)"
         />
         <path
            d="M138.753 281.235c1.41-.712 3.07-.858 4.616-.537s2.978 1.09 4.196 2.096c2.435 2 3.98 4.875 5.42 7.685 3.305 6.455 6.383 13.05 10.338 19.128 2.87 4.4 6.18 8.517 9.082 12.905 3.936 5.95 7.136 12.496 8.456 19.507.888 4.716.86 9.8-1.372 14.058-1.47 2.796-3.85 5.1-6.663 6.525s-6.043 2.017-9.19 1.734c-4.954-.445-9.454-2.925-14.117-4.655-8.275-3.07-17.218-3.803-25.734-6.12-3.592-.977-7.1-2.235-10.75-3-1.606-.342-3.244-.59-4.777-1.18s-2.986-1.566-3.77-3.01c-.55-1.016-.737-2.205-.654-3.357s.42-2.275.865-3.342c.888-2.134 2.2-4.09 2.9-6.296 1.013-3.242.597-6.757-.164-10.068s-1.857-6.56-2.194-9.94c-.15-1.505-.147-3.04.19-4.515s1.027-2.892 2.11-3.95c1.393-1.362 3.344-2.04 5.283-2.23s3.892.07 5.82.35 3.868.6 5.815.5 3.928-.61 5.453-1.824c1.508-1.2 2.456-2.987 3-4.836s.72-3.782.943-5.696.5-3.846 1.23-5.63 1.96-3.428 3.68-4.297z"
            transform="matrix(1 0 0 .98205 0 3.959)"
            fill="#f5bd0c"
            filter="url(#H)"
         />
         <path
            d="M156.407 295.97c2.606 4.713 4.196 10.122 6.78 14.875 2.378 4.372 5.084 8.874 7.5 12.906 1.075 1.795 3.583 4.555 6.12 8.837 2.298 3.88 4.618 9.297 5.917 11.116-.746-2.13-2.28-7.847-4.11-11.923-1.7-3.81-3.7-5.982-4.927-8.03-2.416-4.032-5.017-7.656-7.5-11.5-3.425-5.302-6.036-11.235-9.78-16.28z"
            fill="url(#AZ)"
            filter="url(#I)"
         />
      </g>
   </svg>
);

export default SvgComponent;
